import { provider } from "../../providers";

export interface RemovePlayerFromGroupPayload {
  groupId: number;
  playerId: number;
}

export const RemovePlayerFromGroup = async (params: RemovePlayerFromGroupPayload): Promise<boolean> =>
  provider.Request("/remove-player-from-group", params);
